export const LIMITE_COOLDOWN_MS = 20 * 60 * 1000;
export const LIMITE_COOLDOWN_MINUTOS = 20;

function parseTimestampMs(value) {
  if (value == null) return null;
  const ts = new Date(value).getTime();
  return Number.isFinite(ts) ? ts : null;
}

export function usuarioSemLimiteCooldown(user) {
  return user?.role === 'admin' || user?.role === 'diretor';
}

export function getCooldownRestante(ultimaDevolucao, limiteMs = LIMITE_COOLDOWN_MS) {
  const ultimaMs = parseTimestampMs(ultimaDevolucao);
  if (ultimaMs == null) {
    return { podeAgir: true, msRestante: 0, minutosRestantes: 0, segundosRestantes: 0 };
  }

  const elapsed = Date.now() - ultimaMs;

  if (elapsed < 0) {
    return { podeAgir: true, msRestante: 0, minutosRestantes: 0, segundosRestantes: 0 };
  }

  const msRestante = limiteMs - elapsed;
  if (msRestante <= 0) {
    return { podeAgir: true, msRestante: 0, minutosRestantes: 0, segundosRestantes: 0 };
  }

  return {
    podeAgir: false,
    msRestante,
    minutosRestantes: Math.floor(msRestante / 60000),
    segundosRestantes: Math.floor((msRestante % 60000) / 1000)
  };
}

export function formatCountdown(tempo) {
  const minutos = tempo?.minutosRestantes ?? tempo?.minutos ?? 0;
  const segundos = tempo?.segundosRestantes ?? tempo?.segundos ?? 0;
  return `${minutos}:${String(segundos).padStart(2, '0')}`;
}

export function mensagemCooldown(cooldown) {
  if (!cooldown || cooldown.podeAgir) return null;
  return `Aguarde ${cooldown.minutosRestantes} minuto(s) para solicitar novamente.`;
}
